import { alpha, createTheme, PaletteOptions } from '@mui/material';

declare module '@mui/material/styles' {
    interface Palette {
        primary80: string;
        primary70: string;
        primary50: string;
        primary40: string;
        primary20: string;
        primary10: string;
        white: string;
    }
    interface PaletteOptions {
        primary80: string;
        primary70: string;
        primary50: string;
        primary40: string;
        primary20: string;
        primary10: string;
        white: string;
    }
}

export const primaryColor = {
    main: '#242A36',
    80: '#494E58',
    70: '#6D7179',
    50: '#ABAEB2',
    40: '#E0E1E3',
    20: '#EFEFF0',
    10: '#F8F8F9',
};
export const whiteColor = {
    main: '#ffffff',
    90: alpha('#ffffff', 0.9),
};

export const warningColor = {
    main: '#FFD05A',
    light: '#FFF1CE',
};
export const secondaryColor = {
    main: '#55E5B8',
    light: '#F4FCFC',
};
export const successColor = {
    main: '#30B9BC',
    light: '#DDFAF1',
    mid: '#55D1D3',
};
export const errorColor = {
    main: '#FF8989',
    light: '#FFDEDE',
};

export const grayColor = {
    main: '#E8E8E9',
};

export const gradientColor = {
    main: 'linear-gradient(159.94deg, #FDF2ED -4.37%, #D4F3F4 104.34%)',
    light: 'linear-gradient(85.83deg, #FBF7F6 1.91%, #F4FCFC 99.17%)',
};

const palette: PaletteOptions = {
    primary: {
        main: primaryColor.main,
    },
    secondary: {
        main: secondaryColor.main,
    },
    error: {
        main: errorColor.main,
    },
    warning: {
        main: warningColor.main,
    },
    success: {
        main: successColor.main,
    },
    divider: grayColor.main,
    text: {
        primary: '#242A36',
        secondary: '#494E58',
        disabled: '#ABAEB2',
    },
    primary80: primaryColor['80'],
    primary70: primaryColor['70'],
    primary50: primaryColor['50'],
    primary40: primaryColor['40'],
    primary20: primaryColor['20'],
    primary10: primaryColor['10'],
    white: '#ffffff',
};

export const paletteConfig = createTheme({
    palette,
});
